module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "utility-view",
    class: _vm.value.type
  }, [_c('div', {
    staticClass: "type"
  }, [_c('i', {
    staticClass: "mi"
  }, [_vm._v(_vm._s(_vm.ICON_SET[_vm.value.type] || ''))]), _c('span', [_vm._v(_vm._s(_vm.$formatters.utility_label(_vm.value.type)))])]), (_vm.manual_meter) ? _c('div', {
    staticClass: "mechanical"
  }, [_c('div', {
    staticClass: "sub"
  }, [_vm._v("上次结算")]), (this.paid[_vm.value.type]) ? _c('span', [_vm._v(_vm._s(this.paid[_vm.value.type]) + " " + _vm._s(_vm.$formatters.utility_unit(_vm.value.type)))]) : _c('span', [_vm._v("-")])]) : _vm._e(), _c('div', {
    staticClass: "balance"
  }, [(_vm.manual_meter) ? _c('div', {
    staticClass: "pre-text"
  }, [_vm._v("已使用")]) : _vm._e(), _c('span', [_vm._v(_vm._s(_vm.balance))]), _c('div', {
    staticClass: "unit"
  }, [_vm._v(_vm._s(_vm.$formatters.utility_unit(_vm.value.type)))])]), _c('div', {
    staticClass: "mechanical"
  }, [_c('div', {
    staticClass: "sub"
  }, [_vm._v("机械表")]), (_vm.value.mechanical) ? _c('span', [_vm._v(_vm._s(_vm.value.mechanical) + " " + _vm._s(_vm.$formatters.utility_unit(_vm.value.type)))]) : _c('span', [_vm._v("-")])]), _c('div', {
    staticClass: "time"
  }, [_c('div', {
    staticClass: "sub"
  }, [_vm._v("上次抄表")]), _c('span', [_vm._v(_vm._s(_vm.$formatters.date.from_now(_vm.value.time_last_check)))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ecb66fb","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/components/basic/UtilityView.vue
// module id = 332
// module chunks = 0